import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageView } from '../services/analytics';

const usePageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    pageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
};

export default usePageTracking;
